import { Apps } from '@/dtos'


export const GetAppPath = (app?: Apps | null) => {
  let path: string
  switch (app) {
    case Apps.extra: path = 'extra/'; break
    case Apps.travel: path = 'travel/'; break
    case Apps.property: path = 'property/'; break
    case Apps.leasing: path = 'leasing/'; break
    default: path = ''; break
  }

  return path
}
